import React, { useEffect, useState } from 'react'

import FormBlock from 'components/Forms/FormBlock'
import FormModal from 'components/Modal/FormModal/FormModal'
import Toast, { TOAST_TYPE } from 'components/Toast/Toast'
import Input from 'components/Forms/Input/Input'

import { fieldsValidator, getIsIntStringRule, getIsNotEmptyStringRule, getIsValueRule } from 'utils/fieldsValidator'
import { removeKeyFromObject } from 'utils/common'
import { getMonthlyPrice, getYearlyFormattedPrice } from 'utils/payments'

import styles from './AddInflatedPriceModal.module.scss'

const PriceNote = ({ price, currency, billingCycle }) => {
    if (billingCycle !== 12) return null

    return (
        <div className={styles.priceNote}>
            <span className={styles.price}>{getYearlyFormattedPrice(price, currency, 1)}</span> / year
        </div>
    )
}

const AddInflatedPriceModal = ({ currenciesSymbol, payload: { product, currency }, onSubmit, onClose }) => {
    const [price, setPrice] = useState('')
    const [inflatedPrice, setInflatedPrice] = useState('')

    const [errors, setErrors] = useState({})

    useEffect(() => {
        setPrice(getMonthlyPrice(product.multiCurrencyPrice[currency], product.billingCycleValue))
    }, [])

    const handleSubmit = async () => {
        try {
            setErrors({})

            const validator = new fieldsValidator()

            validator.addFields([
                validator.createField('inflatedPrice', String(inflatedPrice), [
                    getIsValueRule(),
                    getIsNotEmptyStringRule(),
                    getIsIntStringRule(),
                ]),
            ])

            const { isHasErrors, errors } = validator.validate()
            if (isHasErrors) {
                setErrors(errors)
                return
            }

            const price = product.billingCycleValue === 12 ? inflatedPrice * 12 : inflatedPrice
            await onSubmit({ product, currency, price, isInflated: true })

            return true
        } catch (err) {
            console.error(err)
            Toast(TOAST_TYPE.ERROR)
            throw err
        }
    }

    return (
        <FormModal
            headText="Add Inflated Price"
            subHeadText={`${product.name} (${product.productCode})`}
            successText="Inflated price added successfully!"
            actionText="Accept"
            onAction={() => handleSubmit()}
            onClose={() => onClose()}
        >
            <FormBlock label={`Price (${currenciesSymbol[currency]} / Month)`}>
                <PriceNote price={price} billingCycle={product.billingCycleValue} currency={currency} />
                <Input value={price} isDisabled isReadOnly />
            </FormBlock>
            <FormBlock label={`Inflated Price (${currenciesSymbol[currency]} / Month)`}>
                <PriceNote price={inflatedPrice} billingCycle={product.billingCycleValue} currency={currency} />
                <Input
                    value={inflatedPrice}
                    type="number"
                    min={1}
                    error={errors.inflatedPrice}
                    onChange={value => {
                        setInflatedPrice(value)
                        setErrors(removeKeyFromObject(errors, 'inflatedPrice'))
                    }}
                />
            </FormBlock>
        </FormModal>
    )
}

export default AddInflatedPriceModal
